<template>
  <div class="result_container">
    <!--<div class="hd">-->
      <!--<span class="header_title">领取优惠券</span>-->
    <!--</div>-->
    <div class="operation_box">

      <i class="icon-font emkt-icon-duigou research-font-color" style="font-size: 60px;"></i>
      <span class="main" :lines="1">{{displayResult}}</span>
      <span class="submain" :lines="1" >{{text}}</span>
      <div class="return-button research-background-color" @click="goHome"><span class="tag">返回主页</span></div>
      <a :href="lotteryUrl" v-if="ifShowLottery && lotteryUrl">
        <img src="/emktResources/resocurces/img/promotion/首单抽奖.png" class="lottery-image">
      </a>
    </div>
    <div class="modal-overlay modal-overlay-visible" v-if="ifShowInstruction">
      <div class="lottery-background">
        <img @click="getCouponForSelf" src="/emktResources/resocurces/img/promotion/coupon-self.png" style="position: absolute;width: 105px;top: 400px;left: 50px;">
        <img @click="getCouponForFriend" src="/emktResources/resocurces/img/promotion/coupon-gift.png" style="position: absolute;width: 105px;top: 400px;right: 50px;">
        <img @click="ifShowInstruction = false" src="/emktResources/resocurces/img/promotion/lottery-close.png" style="position: absolute;width: 28px;left: 260px;top: 70px;">
        <div class="lottery-discount" v-if="promotions618Used && promotions618Used.length > 0">
          <div v-for="pro in promotions618Used">
            <div v-if="promotions618Used.length === 1" style="line-height: 10px;opacity: 0;">折扣券</div>
            <div v-if="pro.categoryId === 20">定制产品<span style="font-size: 20px;">{{pro.discount}}</span>折</div>
            <div v-else>现货及质粒产品<span style="font-size: 20px;">{{pro.discount}}</span>折</div>
          </div>
          <div style="transform: scale(0.8);color: #424242;">使用截止日期2020.7.18</div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapState, mapGetters, mapMutations} from 'vuex'
  import Emkt from '../../emkt'
  import wx from 'wx'
  export default {
    mounted () {
      this.getLottery()
    },
    computed: {
      ...mapState([
        'sessionInfo', 'myOrder', 'showLotteryAlready'
      ]),
      ...mapGetters([
        'hasLogin', 'customerName'
      ]),
      mobile () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile
      },
      enterpriseName () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName
      },
      customerNo () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo
      },
      isWaitApprove () {
        if (!this.$route || !this.$route.query || !this.$route.query.BOrders) {
          return false
        }
        return this.$route.query.BOrders[0] && this.$route.query.BOrders[0].researchGroupApproveResult === Emkt.RESEARCH_GROUP_APPROVE_RESULT_WAIT_APPROVE
      },
      displayResult () {
        return this.isWaitApprove ? '订单正在审批中' : '下单成功'
      }
    },
    data () {
      return {
        constants: {},
        text: '感谢您的购买！',
        lotteryUrl: '',
        ifShowLottery: true,
        ifShowInstruction: false,
        promotions618Used: [],
        ifIsMonthlyFirstOrder: true
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_WEAPP_MYORDERS'
      ]),
      goHome () {
        if (Emkt.isWapp) {
          wx.miniProgram.switchTab({
            url: '/pages/index/index'
          })
        } else {
          this.$router.replace({name: 'home'})
        }
      },
      getLottery () {
        this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
          if (res.body.result && res.body.result.length > 0) {
            let lotteryInfo = res.body.result[0]
            this.$nextTick(this.showLottery(lotteryInfo))
          } else {
            return this.$weui.topTips('暂无抽奖信息')
          }
        })
      },
      showLottery (lotteryInfo) {
        // 是否参与抽奖，刷新后不获取抽奖信息
        const paidOrderId = this.$route.params.orderId
        if (!paidOrderId || paidOrderId === undefined) {
          return this.$weui.topTips('暂无抽奖信息')
          // return $.toast('暂无抽奖信息')
        }
        this.$weui.loading('正在查询活动信息')
        // 先判断是不是首单，此值需要传到优惠券领取页面
        // this.ifIsMonthlyFirstOrder = this.isdaysFirstOrder()
        // this.getPromotions618()
        const lotteryStartDT = new Date(lotteryInfo.startDT.year, lotteryInfo.startDT.month, lotteryInfo.startDT.dayOfMonth, lotteryInfo.startDT.hourOfDay, lotteryInfo.startDT.minute, lotteryInfo.startDT.second)
        const lotteryEndDT = new Date(lotteryInfo.endDT.year, lotteryInfo.endDT.month, lotteryInfo.endDT.dayOfMonth, lotteryInfo.endDT.hourOfDay, lotteryInfo.endDT.minute, lotteryInfo.endDT.second)
        const now = new Date()
        if (now >= lotteryStartDT && now <= lotteryEndDT) {
          if (!this.customerNo) return
          const queryParam = {
            customerNo: this.customerNo
          }
          this.UPDATE_WEAPP_MYORDERS({})
          this.gcapi('getAllOrdersByCustomerNoOrResearchGroupNo', queryParam).then(res => {
            this.$weui.loading().hide()
            if (res && res.body.result) {
              this.orderObject = res.body.result
              this.UPDATE_WEAPP_MYORDERS(this.orderObject)
              console.log('getAllOrdersByCustomerNoOrResearchGroupNo', this.orderObject, 'this.tabIndex=', this.tabIndex)
              var waitDeliverAndFinishedOrders = this.orderObject.executedOrderList
              const orderSet = new Set()
              const orders = waitDeliverAndFinishedOrders.filter(order => {
                return order.id === parseInt(paidOrderId)
              })
                // 判断当前订单金额是否满足抽奖最低金额
              if (lotteryInfo.requiredMoney !== null) {
                if (orders.length === 1) {
                  this.ifIsMonthlyFirstOrder = orders[0].price >= lotteryInfo.requiredMoney
                } else {
                  this.ifIsMonthlyFirstOrder = false
                }
              }
              waitDeliverAndFinishedOrders.filter(order => {
                if (lotteryInfo.requiredMoney !== null) {
                  let orderTime = new Date(order.orderTime.replace(/-/g, '/'))
                  if (orderTime >= lotteryStartDT && orderTime <= lotteryEndDT && order.price >= lotteryInfo.requiredMoney) {
                    orderSet.add(order)
                  }
                } else {
                  if (new Date(order.orderTime) >= lotteryStartDT && new Date(order.orderTime) <= lotteryEndDT) {
                    orderSet.add(order)
                  }
                }
              })
              // 仅第一次满足抽奖条件才可跳出抽奖活动，后续不再可跳出活动
              if (orderSet.size === 1 && this.ifIsMonthlyFirstOrder) {
                this.$weui.loading().hide()
                  // $.hidePreloader()
                const url = lotteryInfo.url
                      // 享受520促销，判断是否有抽奖记录
                      // if (this.has520Promotion()) {
                      //   const lotteryRecord = {
                      //     guid: lotteryInfo.guid,
                      //     customerNo: this.sessionInfo.customerInfo.customerNo
                      //   }
                      //   this.gcapi('checkedLotteryrecords', lotteryRecord).then(res => {
                      //     if (!res.body.result) {
                      //       $.toast('您已经抽过奖了')
                      //       return
                      //     }
                      //     let domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/a-178-show.png"></a></div>'
                      //     const self = this
                      //     $.modal({
                      //       text: domText,
                      //       buttons: [{
                      //         text: '关闭'
                      //       }],
                      //       onClick: function () {
                      //         $.modal({
                      //           text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
                      //           buttons: [{
                      //             text: '确定放弃',
                      //             onClick: function () {
                      //             }
                      //           }, {
                      //             text: '<a href="' + url + '">返回抽奖</a>',
                      //             onClick: () => {
                      //               // 防止iphone手机报错，加@抑制报错信息
                      //               self.gcapi('@submitLotteryrecords', lotteryRecord)
                      //             }
                      //           }]
                      //         })
                      //       }
                      //     })
                      //     $('#lottery').click(() => {
                      //       self.gcapi('@submitLotteryrecords', lotteryRecord).then(res => {})
                      //       $.closeModal()
                      //     })
                      //   })
                      // } else {
                      // 每个月首单抽奖，无需判断是否有抽奖记录
                let domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></a></div>'
                      // const self = this
                      // this.$weui.dialog({
                      //   content: domText,
                      //   buttons: [{
                      //     label: '关闭',
                      //     type: 'primary',
                      //     onClick: () => {
                      //       this.$weui.dialog({
                      //         content: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
                      //         buttons: [{
                      //           type: 'default',
                      //           label: '确定放弃',
                      //           onClick: function () {
                      //           }
                      //         }, {
                      //           type: 'primary',
                      //           label: '<a href="' + url + '">返回抽奖</a>',
                      //           onClick: () => {
                      //           }
                      //         }]
                      //       })
                      //     }
                      //   }]
                      // })
                $.modal({
                  text: domText,
                  buttons: [{
                    text: '关闭'
                  }],
                  onClick: function () {
                    $.modal({
                      text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
                      buttons: [{
                        text: '确定放弃',
                        onClick: function () {
                        }
                      }, {
                        text: '<a href="' + url + '">返回抽奖</a>',
                        onClick: () => {
                        }
                      }]
                    })
                  }
                })
              } else {
                this.$weui.topTips('暂无抽奖信息')
              }
            }
          })
        }
      },
      isMonthlyFirstOrder () {
        if (!this.myOrder) return true
        let currentMonth = new Date().getMonth() + 1
        let currentYear = 2020
        if (![4, 5, 6].includes(currentMonth)) return true
        const waitDeliverAndFinishedOrders = [...this.myOrder.waitDeliverOrders, ...this.myOrder.finishedOrders]
        const orderSet = new Set()
        waitDeliverAndFinishedOrders.filter(order => new Date(order.payDT.replace(/-/g, '/')).getFullYear() === currentYear).forEach(order => {
          if (new Date(order.payDT.replace(/-/g, '/')).getMonth() + 1 === currentMonth) {
            orderSet.add(order.payDT.replace(/-/g, '/'))
          }
        })
        console.log('orderSet', orderSet)
        return orderSet.size === 1
      },
      getPromotions618 () {
        const paidOrder = this.$route.query.order
        if (!paidOrder || JSON.stringify(paidOrder) === '{}' || !paidOrder.merchandises) {
          this.promotions618Used = []
        }
        const promotionGuids618 = Object.keys(Emkt.promotions618)
        const promotionsSet = new Set()
        paidOrder.merchandises.forEach(merchandise => {
          merchandise && merchandise.perferPromotions && merchandise.perferPromotions.forEach(promotion => {
            if (promotion && promotionGuids618.includes(promotion.promotionGuid)) {
              promotionsSet.add(promotion.promotionGuid)
            }
          })
        })
        this.promotions618Used = [...promotionsSet].sort().map(guid => Emkt.promotions618[guid])
        const guids = this.promotions618Used.map(pro => pro.guid).join(',')
        Emkt.setStoreItem('promotionGuids618Used', guids)
        console.log('promotions618Used', this.promotions618Used)
      },
      getCouponForSelf () {
        this.ifShowInstruction = false
        if (!this.hasLogin) {
          return this.$weui.alert('请先登录')
          // return alert('请先登录')
        }
        if (!this.promotions618Used || this.promotions618Used.length === 0) {
          return this.$weui.alert('无可领优惠券')
          // return alert('无可领优惠券')
        }
        if (!this.customerNo || !this.mobile || !this.customerName || !this.enterpriseName) {
          return this.$weui.alert('个人信息不完整，请联系业务员')
          // return alert('个人信息不完整，请联系业务员')
        }
        const formCollectionActivity = {
          'customerNo': this.customerNo,
          'customerMobile': this.mobile,
          'customerName': this.customerName,
          'customerEnterpriseName': this.enterpriseName,
          'activityName': '618领取优惠券',
          'attachmentName': Emkt.getLocalStorage('promotionGuids618Used'),
          'additionalinfos': []
        }
        formCollectionActivity['additionalinfos'].push({
          'columnName': '券是否自用',
          'columnValue': '券自用'
        })
        formCollectionActivity['additionalinfos'].push({
          'columnName': '持券者电话号码',
          'columnValue': this.mobile
        })
        formCollectionActivity['additionalinfos'].push({
          'columnName': '持券者姓名',
          'columnValue': this.customerName
        })
        const formCollectionActivityList = []
        formCollectionActivityList.push(formCollectionActivity)
        this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then((response) => {
          if (response.body.result === false) {
            return this.$weui.topTips('提交失败')
            // return $.toast('提交失败')
          } else {
            // 领取优惠券后，清空订单中使用的618促销guids
            Emkt.setStoreItem('promotionGuids618Used', '')
            let result, text
            result = '领取成功'
            text = '折扣券将在3-5个工作日发放完毕'
            this.$router.replace({name: 'OperationResult', query: {result, text, 'showLottery': this.ifIsMonthlyFirstOrder}})
          }
        })
      },
      getCouponForFriend () {
        this.$router.replace({name: 'SearchContactWithoutDetail', query: {'showLottery': this.ifIsMonthlyFirstOrder}})
      }
    }
  }
</script>
<style scoped>
  .result_container {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100%;
  }
  .operation_box {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100vw;
    height: 100vh;
    padding-top: 100px;
  }
  .hd {
    display: flex;
    position: fixed;
    top:0;
    left:0;
    align-items: center;
    flex-direction: row;
    width: 100vw;
    height: 56px;
    z-index: 10;
    justify-content: center;
    background-color: #013C8E;
  }

  .header_title {
    opacity: 1;
    /*margin-left: 29.33vw;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
  }

  .bd {
    position: relative;
    margin-top: 15vh;
    width: 60px;
  }
  .lottery-background {
    background-image: url('/emktResources/resocurces/img/promotion/lottery-background.png');
    background-size: 100% 100%;
    width: 320px;
    height: 568px;
    margin: 0 auto;
    position: relative;
  }
  .lottery-discount {
    position: absolute;
    width: 170px;
    height: 70px;
    top: 310px;
    left: 75px;
    font-size: 14px;
    text-align: center;
    color: #DF4608;
    line-height: 22px;
  }
  .main {
    position: relative;
    opacity: 1;
    margin-top: 20px;
    max-width: 320px;
    white-space: nowrap;
    color: #424242;
    font-size: 20px;
    font-weight: 400;
  }

  .submain {
    position: relative;
    opacity: 1;
    margin-top: 10px;
    max-width: 320px;
    text-align: center;
    color: #929292;
    font-size: 12px;
    font-weight: 400;
  }

  .return-button {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 51px;
    border-radius: 5.87vw;
    width: 320px;
    height: 44px;
  }

  .tag {
    opacity: 1;
    max-width: 83.47vw;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }

   .lottery-image {
     width: 90%;
     margin: 20px auto;
     display: block;
   }

</style>




// WEBPACK FOOTER //
// SuccessPay.vue?0a9064a1